import { useCallback } from "react";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

interface MobilePaginationProps {
  page: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  totalItems?: number;
  pageSize?: number;
}

export default function MobilePagination({
  page,
  totalPages,
  onPageChange,
  totalItems,
  pageSize,
}: MobilePaginationProps) {
  const handlePrev = useCallback(() => {
    if (page > 1) onPageChange(page - 1);
  }, [page, onPageChange]);

  const handleNext = useCallback(() => {
    if (page < totalPages) onPageChange(page + 1);
  }, [page, totalPages, onPageChange]);

  const rangeText =
    totalItems != null && pageSize != null
      ? `${(page - 1) * pageSize + 1}–${Math.min(page * pageSize, totalItems)} of ${totalItems}`
      : `${page} of ${totalPages}`;

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "8px",
        padding: "4px 16px",
      }}
    >
      <IconButton
        onClick={handlePrev}
        disabled={page <= 1}
        aria-label="Previous page"
        sx={{ width: 44, height: 44 }}
      >
        <ChevronLeftIcon />
      </IconButton>
      <Typography variant="body2" sx={{ color: "#666", minWidth: "80px", textAlign: "center" }}>
        {rangeText}
      </Typography>
      <IconButton
        onClick={handleNext}
        disabled={page >= totalPages}
        aria-label="Next page"
        sx={{ width: 44, height: 44 }}
      >
        <ChevronRightIcon />
      </IconButton>
    </Box>
  );
}
